import { INSURANCE_TYPES } from '../../../../constants';
import {
  buildQuestionnaireTabOptions,
  withoutQuestionnaireTabStatusIcons,
} from '../../common/hooks';
import { ONBOARDING_TAB_CONFIGS } from '../constants';
import { INSURANCE_TYPE_TAB_IDS } from '../components/forms/insurance/constants';
import { useInsuranceExtractionMap } from '../components/forms/insurance/hooks';
import { isExtractionInProgress } from '../components/forms/insurance/hooks/utils';
import useIsOnboardingQuestionnaireReadOnly from './useIsOnboardingQuestionnaireReadOnly';
import useOnboardingTabStatuses from './useOnboardingTabStatuses';

import type { FButtonMenuOption } from '../../../../components/baseV2';
import type { OnboardingTabId } from '../types';

export default function useOnboardingTabMenuOptions(
  basePath: string,
): ReadonlyArray<FButtonMenuOption> {
  const statuses = useOnboardingTabStatuses();
  const extraction = useInsuranceExtractionMap();
  const { isCompleted } = useIsOnboardingQuestionnaireReadOnly();

  const decorate = (tabId: OnboardingTabId) => {
    const primary = extraction[INSURANCE_TYPES.PRIMARY];
    const secondary = extraction[INSURANCE_TYPES.SECONDARY];
    if (tabId === INSURANCE_TYPE_TAB_IDS[INSURANCE_TYPES.PRIMARY]) {
      return {
        loading: primary != null && isExtractionInProgress(primary.status),
        error: primary?.needsReview ?? false,
      };
    }
    if (tabId === INSURANCE_TYPE_TAB_IDS[INSURANCE_TYPES.SECONDARY]) {
      return {
        loading: secondary != null && isExtractionInProgress(secondary.status),
        error: secondary?.needsReview ?? false,
      };
    }
    return {};
  };

  const options = buildQuestionnaireTabOptions(
    ONBOARDING_TAB_CONFIGS,
    statuses,
    basePath,
    decorate,
  );

  return isCompleted ? withoutQuestionnaireTabStatusIcons(options) : options;
}
